import React from "react";
import {
  WhmButton,
  WhmStack,
  whmTheme,
  WhmTypography,
} from "@securitize/reactjs-whm";
import { ReactComponent as Error } from "../../assets/Error.svg";
import { ReactComponent as RefreshIcon } from "@securitize/assets-sec-ui/dist/icons/svg/refresh.svg";
import { translationKeys } from "../../contexts/I18nContext";
import { useTranslation } from "../../hooks/useTranslation";

interface ErrorPageProps {
  onRefresh?: (() => void) | (() => Promise<any>);
}
export const ErrorPage: React.FC<ErrorPageProps> = ({ onRefresh }) => {
  const { getTranslation: t } = useTranslation();
  const refresh = onRefresh || (() => window.location.reload());

  return (
    <WhmStack sx={{ padding: "24px", alignItems: "center" }}>
      <Error style={{ height: "124px" }} />
      <WhmTypography
        variant={"h4"}
        sx={{ marginTop: "16px", textAlign: "center" }}
      >
        {t(translationKeys.ERROR_PAGE_TITLE)}
      </WhmTypography>
      <WhmTypography
        variant={"body1"}
        sx={{
          textAlign: "center",
          marginTop: "8px !important",
          marginBottom: "24px !important",
        }}
      >
        {t(translationKeys.ERROR_PAGE_DESCRIPTION)}
      </WhmTypography>

      <WhmTypography
        variant={"body1"}
        sx={{
          textAlign: "center",
          fontSize: "14px",
          a: {
            textDecoration: "underline !important",
            color: whmTheme.palette.primary.main,
          },
        }}
      >
        {t(translationKeys.ERROR_PAGE_FOOTER)}
        <a href="mailto:investorsupport@securitize.io">
          investorsupport@securitize.io
        </a>
      </WhmTypography>
      <WhmButton
        onClick={refresh}
        variant="contained"
        color="primary"
        data-test-id="profile-error-cta"
        sx={{ marginTop: "24px !important" }}
        endIcon={<RefreshIcon fill={whmTheme.palette.primary.contrastText} />}
      >
        {t(translationKeys.ERROR_PAGE_ACTION)}
      </WhmButton>
    </WhmStack>
  );
};
